// Home page hero slider. Slides cross-fade on opacity, so nothing here moves
// the DOM or measures a track -- the controller only ever decides which slide
// carries data-active and which dot is selected, and the stylesheet owns every
// duration. Inactive slides get `inert` so their links leave the tab order and
// the accessibility tree along with their pointer target.
class KludiHero extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('[data-kludi-hero-slide]'));
    this.dots = Array.from(this.querySelectorAll('[data-kludi-hero-dot]'));
    this.index = Math.max(
      this.slides.findIndex((slide) => slide.hasAttribute('data-active')),
      0
    );

    if (this.slides.length < 2) return;

    this.querySelector('[data-kludi-hero-prev]')?.addEventListener('click', () => this.step(-1));
    this.querySelector('[data-kludi-hero-next]')?.addEventListener('click', () => this.step(1));
    this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.go(index)));

    this.startAutoplay();
  }

  disconnectedCallback() {
    this.stopAutoplay();
  }

  get interval() {
    return parseInt(this.getAttribute('data-autoplay'), 10) || 0;
  }

  startAutoplay() {
    if (!this.interval) return;
    this.timer = window.setInterval(() => this.step(1), this.interval);
  }

  stopAutoplay() {
    if (this.timer) window.clearInterval(this.timer);
    this.timer = null;
  }

  step(direction) {
    const count = this.slides.length;
    this.go((this.index + direction + count) % count);
  }

  // any manual move restarts the dwell, so a slide picked by hand gets the
  // full interval rather than whatever was left of the previous one
  go(index) {
    if (index === this.index) return;

    this.slides.forEach((slide, position) => {
      slide.toggleAttribute('data-active', position === index);
      slide.toggleAttribute('inert', position !== index);
    });

    this.dots.forEach((dot, position) => {
      dot.setAttribute('aria-selected', position === index ? 'true' : 'false');
    });

    this.index = index;
    this.stopAutoplay();
    this.startAutoplay();
  }
}

window.customElements.define('kludi-hero', KludiHero);
